<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-if="iconShow" v-slot:activator="{ on, attrs }">
      <ButtonShow :openModal="openModal" v-bind="attrs" v-on="on" />
    </template>
    <template v-else v-slot:activator="{ on, attrs }">
      <v-btn text elevation="0" class="pa-0" @click="openModal" v-bind="attrs" v-on="on">
        <v-tooltip bottom color="#2C2C2C">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text elevation="0" class="pa-0" v-bind="attrs" v-on="on">
              <slot name="text"/>
            </v-btn>
          </template>
          <span>{{ localStorage.translations.pages.common['buttons']['prosmotr'] }}</span>
        </v-tooltip>
      </v-btn>
      
    </template>
    <transition-group v-if="dialog" :duration="150">
      <PDFJSViewer key="PDFJSViewer" :url="apiDomain + '/' + url" />
      <button key="button" class="customBtn fixed" @click="closeModal">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.66648 1.33328C6.6666 1.19424 6.62326 1.05865 6.5425 0.945471C6.46175 0.832293 6.34763 0.747194 6.21612 0.702083C6.08461 0.656972 5.94228 0.654107 5.80906 0.693888C5.67584 0.73367 5.55839 0.814108 5.47314 0.923945L0.806478 6.92394C0.715442 7.04097 0.666016 7.18501 0.666016 7.33328C0.666016 7.48155 0.715442 7.62558 0.806478 7.74261L5.47314 13.7426C5.55839 13.8524 5.67584 13.9329 5.80906 13.9727C5.94228 14.0125 6.08461 14.0096 6.21612 13.9645C6.34763 13.9194 6.46175 13.8343 6.5425 13.7211C6.62326 13.6079 6.6666 13.4723 6.66648 13.3333V10.6733C10.2525 10.7479 11.9751 11.4286 12.8405 12.1686C13.6631 12.8719 13.8138 13.6993 13.9705 14.5659L14.0111 14.7893C14.0411 14.9491 14.1283 15.0924 14.2566 15.1924C14.3848 15.2924 14.5451 15.342 14.7074 15.332C14.8697 15.322 15.0227 15.2531 15.1377 15.1381C15.2527 15.0232 15.3217 14.8702 15.3318 14.7079C15.4458 12.8759 15.2745 10.2213 13.9805 8.00061C12.7245 5.84528 10.4625 4.18794 6.66648 4.01461V1.33328Z"
            fill="#F2F2F2"
          />
        </svg>
        {{ localStorage.translations.pages.common['buttons']['nazad'] }}
      </button>
    </transition-group>
  </v-dialog>
</template>

<script>
import ButtonShow from 'components/ButtonShow'
import PDFJSViewer from 'components/PDFJSViewer'

export default {
  name: 'ProjectSchemesAndDocumentsPdfModal',
  components: {
    ButtonShow,
    PDFJSViewer,
  },
  // props: ['id', 'url'],
  props: {
    id: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    iconShow: Boolean,
  },
  data() {
    return {
      dialog: false,
    }
  },
  watch: {},
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
}
</script>

<style lang="scss" scoped>
.modalBody {
  width: 100%;
  height: 100vh;
}
.customBtn {
  padding: 15px !important;
  text-transform: capitalize;
  &.fixed {
    position: fixed;
    right: 25px;
    bottom: 10%;
  }
}
</style>